import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { KYMW2403Component } from './kymw2403.component';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { AppCommonsModule } from '../../../commons/app-commons.module';

/**
 * セクション追加画面 モジュール設定クラス
 *
 * @export KYMW2403Module
 * @class KYMW2403Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    WjNavModule,
    WjInputModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW2403Component,
  ],
  providers: [
  ],
})

export class KYMW2403Module { }
